var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowtemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 12.9167V12.8167H7.5H4.16667H4.06667V12.9167V16.25V16.35H4.16667H7.5H7.6V16.25V12.9167ZM10.0853 4.83116L10 4.69163L9.91469 4.83116L8.31469 7.44782L8.22164 7.59999H8.4H11.6H11.7784L11.6853 7.44782L10.0853 4.83116ZM9.06667 11.35V17.8167H2.6V11.35H9.06667ZM5.59497 9.06666L10 1.85843L14.405 9.06666H5.59497ZM14.5833 10.9333C16.6114 10.9333 18.2333 12.5552 18.2333 14.5833C18.2333 16.6114 16.6114 18.2333 14.5833 18.2333C12.5552 18.2333 10.9333 16.6114 10.9333 14.5833C10.9333 12.5552 12.5552 10.9333 14.5833 10.9333ZM14.5833 12.4C14.0043 12.4 13.4489 12.63 13.0395 13.0395C12.63 13.4489 12.4 14.0043 12.4 14.5833C12.4 15.1624 12.63 15.7177 13.0395 16.1272C13.4489 16.5366 14.0043 16.7667 14.5833 16.7667C15.1624 16.7667 15.7177 16.5366 16.1272 16.1272C16.5366 15.7177 16.7667 15.1624 16.7667 14.5833C16.7667 14.0043 16.5366 13.4489 16.1272 13.0395C15.7177 12.63 15.1624 12.4 14.5833 12.4Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowtemplate);
export default __webpack_public_path__ + "static/media/showtemplate.eeceef28812991e4c4b7bc16dd4c909a.svg";
export { ForwardRef as ReactComponent };